import { integrateWithTheme } from '@expPlatform/embeds/integrations/shopify/integrations'

import { EventTypeReady } from '@core/customEvent/eventTypeReady'

import { autoEmbed } from './autoEmbed'
import { setup } from './hydrations'

setup()
autoEmbed()
document.addEventListener(EventTypeReady.FW_SHOPPING_READY, () => {
  integrateWithTheme(window.Shopify?.theme)
})
